import { useInjectSaga } from 'Utils/ReduxInjectors';
import { sliceKey as customWidgetSliceKey } from 'Slice/CustomWidgetSlice';
import { CustomWidgetSaga } from 'Saga/CustomWidgetSaga';

const CustomWidgetRouteInjector = function CustomWidgetRouteInjector() {
  useInjectSaga({ key: customWidgetSliceKey, saga: CustomWidgetSaga });
  return null;
};

export default CustomWidgetRouteInjector;
